import { TEventsState, TEventsActions } from '../../types/events';

export const eventsActionTypes = {
  GET_ALL_EVENTS_REQUEST: 'EVENTS/GET_ALL_EVENTS_REQUEST',
  GET_ALL_EVENTS_SUCCESS: 'EVENTS/GET_ALL_EVENTS_SUCCESS',
  SET_LOADING: 'EVENTS/SET_LOADING',
} as const;

const initialState: TEventsState = {
  all: [],
  loading: false,
};

export default (state: TEventsState = initialState, action: TEventsActions): TEventsState => {
  switch (action.type) {
    case eventsActionTypes.GET_ALL_EVENTS_SUCCESS:
      return {
        ...state,
        all: action.payload,
      };

    case eventsActionTypes.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    default:
      return state;
  }
};

export const actions = {
  getAllEventsRequest: (userId: string, category: string, dateFrom: Date, dateTo: Date) => ({
    payload: { userId, category, dateFrom, dateTo },
    type: eventsActionTypes.GET_ALL_EVENTS_REQUEST,
  }),
};
